import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { FC, useState } from 'react';
import checkerImage from "shared/assets/img/checker.png";
import { Logo } from './NavigationLogo';
import { useLangContext } from 'shared/features/Language';
import { ModalCountryConfirmDialog } from 'shared/components';
import './header.scss';

type Props = {
  mode: 'dark' | 'light';
};

export const PublicHeader: FC<Props> = ({ mode }) => {
  const theme = useTheme();
  const { lang, changeLang } = useLangContext();
  const [openModal, setOpenModal] = useState(false);

  const handleChange = (event: SelectChangeEvent) => {
    changeLang(
      event.target.value as
        | "en"
        | "es"
        | "it"
        | "pl"
        | "de"
        | "fr"
        | "cz"
        | "hu"
        | "gr"
        | "dk"
        | "pt",
    );
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const langs = ['en', 'es', 'it', 'pl', 'de', 'fr', 'cz', 'hu', 'gr', 'dk', 'pt'];

  return (
    <Container maxWidth='xl' sx={{padding: {lg:"20px", xs:'10px'} }}>
      <ModalCountryConfirmDialog open={openModal} handleClose={handleClose} />
      <Grid
        container
        direction="row"
        wrap="nowrap"
        sx = {{
          justifyContent: 'space-between',
          backgroundColor: theme.palette.text.primary,
          padding: {lg:"10px", xs:'5px'}
        }}
      >
        <Grid item>
          <Box
            sx={{
              width: {lg: "74px", xs: '48px'},
              paddingTop: {lg: "24px", xs: '9px'}
            }}
            component="img"
            src={checkerImage}
          />
        </Grid>

        <Grid
          item
          container
          direction="column"
          width="auto"
          sx={{
            alignItems: 'center',
            gap: {lg: '0', xs: '5px'},
            flexDirection: 'row'
          }}
          className='header_logo-container'
        >

          <Grid item className='header_logo-wrapper'>
            <Logo />
          </Grid>

          <Grid item sx={{ flex: '0 1'}}>
            <FormControl sx={{width: {lg: '100px', xs: '76px'}}}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={lang}
                onChange={handleChange}
                sx={{
                  svg: {
                    color: theme.palette.primary.main
                  },
                }}
              >
                {langs.map((lang, index) => (
                  <MenuItem value={lang} key={index}>
                    <Typography
                      variant="overline"
                      sx={{
                        fontSize: '16px',
                        lineHeight: '1.5',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: theme =>
                          `${
                            mode === 'dark'
                              ? theme.palette.primary.main
                              : theme.palette.secondary.main
                          }`,
                      }}
                    >
                      {lang.toLocaleUpperCase()}
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>


        </Grid>

        <Grid item>
          <Box
            sx={{
              width: {lg: "74px", xs: '48px'},
          }}
            component="img"
            src={checkerImage}
          />
        </Grid>
      </Grid>
    </Container>
  );
};
